import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, NgZone, PLATFORM_ID, signal } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HomepageService } from 'retail/app/core/providers/homepage.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { handleImageError, rxSignal } from 'shared-ui/utils';

@Component({
  standalone: false,
  selector: 'app-homepage',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent {
  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);
  private meta = inject(Meta);
  private title = inject(Title);
  private homepageService = inject(HomepageService);

  projectsLimit = signal(3);
  brands = rxSignal(this.homepageService.getBrands(), []);
  showedBrands = rxSignal(this.getBrands(), []);
  lastProducts = rxSignal(this.homepageService.getLastProducts(), []);
  recProducts = rxSignal(this.homepageService.getRecProducts(), []);
  promoLinks = rxSignal(this.homepageService.getPromoLinks(), []);
  lastProjects = rxSignal(this.homepageService.getLastProjects(this.projectsLimit()), { total: 0, items: [] });

  constructor() {
    this.title.setTitle('BEROP.cz');
    this.meta.updateTag({
      name: 'keywords',
      content:
        'kotle, tepelné čerpadla, dům a zahrada, sekačky, náhradní díly, montáže, servis, opava, ostrava, viaflames, opop, regulus',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'Obchod s kotli, tepelnými čerpadly, jejich montáž a servis, a také prodej sortimentu pro Vaši zahradu a náhradních dílů.',
    });
  }

  onImgError = handleImageError;

  private getBrands() {
    if (!isPlatformBrowser(this.platformId)) {
      return of(this.brands().slice(0, 5));
    }
    return new Observable<number>(sub => {
      let n = 0;
      sub.next(n++);
      const id = this.ngZone.runOutsideAngular(() => setInterval(() => this.ngZone.run(() => sub.next(n++)), 5_000));
      return () => clearInterval(id);
    }).pipe(map(seq => (seq % 2 === 0 ? this.brands().slice(0, 5) : this.brands().slice(5))));
  }
}
